import React from 'react';
import { Edit2Liner18 } from "../../icons";
import { IconButton } from "../IconButton";
import { Typography } from "../Typography";
import styles from "./MobileTextField.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function MobileSummaryCard(props) {
  const {
    title,
    body,
    titleTestId,
    bodyTestId,
    editButtonTestId,
    onEdit
  } = props;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.root,
    children: [/*#__PURE__*/_jsxs(Typography, {
      ellipsis: true,
      children: [/*#__PURE__*/_jsx(Typography, {
        skin: "secondary",
        "data-testid": titleTestId,
        children: title
      }), /*#__PURE__*/_jsx(Typography, {
        "data-testid": bodyTestId,
        children: body
      })]
    }), /*#__PURE__*/_jsx(IconButton, {
      noPadding: true,
      className: styles.editButton,
      onClick: onEdit,
      "data-testid": editButtonTestId,
      children: /*#__PURE__*/_jsx(Edit2Liner18, {})
    })]
  });
}